

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { IstanzeProcedimentoDTO } from "../dto/istanze-procedimentoDTO";
import { IstanzeProcedimentoVO } from "../vo/istanze-procedimentoVO";




@Injectable({
    providedIn: 'root'
})
export class MapperIstanzaProcedimento implements MapperInterface<IstanzeProcedimentoDTO, IstanzeProcedimentoVO> {

    convertVoToDto(vo: IstanzeProcedimentoVO): IstanzeProcedimentoDTO {
        if (vo != null) {
            const dto = new IstanzeProcedimentoDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.id = vo.id;
            dto.nome = vo.nome;
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: IstanzeProcedimentoDTO): IstanzeProcedimentoVO {
        if (dto != null) {
            const vo = new IstanzeProcedimentoVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.id = dto.id;
            vo.nome = dto.nome;

            return vo;
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: IstanzeProcedimentoVO[]): IstanzeProcedimentoDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: IstanzeProcedimentoDTO[]): IstanzeProcedimentoVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
